var _defs, _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtensionEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #010101;\n        opacity: .05;\n      }\n\n      .cls-2 {\n        fill: #f2f2f2;\n      }\n\n      .cls-3 {\n        fill: #807772;\n      }\n\n      .cls-4 {\n        fill: #d9d9d9;\n      }\n\n      .cls-5 {\n        fill: #3b3938;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.64,11.66H26.49c-2.49,0-4.5,2.02-4.5,4.5V83.84c0,2.49,2.02,4.5,4.5,4.5h51.5c2.49,0,4.5-2.02,4.5-4.5V37.52c0-1.19-.47-2.34-1.32-3.18L59.82,12.98c-.84-.84-1.99-1.32-3.18-1.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.18,34.34l-1.3-1.3c.84,.84,1.32,1.99,1.32,3.18v46.32c0,2.49-2.02,4.5-4.5,4.5H25.19c-.91,0-1.75-.27-2.46-.73,.8,1.23,2.19,2.04,3.77,2.04h51.5c2.49,0,4.5-2.02,4.5-4.5V37.52c0-1.19-.47-2.34-1.32-3.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M82.08,35.62c-.24-.49-.56-.95-.95-1.33L59.9,13.06c-.41-.41-.88-.74-1.4-.99V31.32c0,2.39,1.94,4.34,4.34,4.34h19.25l-.02-.04Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.73,40.85c-2.34,0-4.23,1.9-4.23,4.23v23.72H63.92c1.99,0,3.72-1.39,4.14-3.34l4.23-19.48c.57-2.64-1.44-5.13-4.14-5.13H21.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "17.56 68.78 21.99 74.25 21.99 68.8 17.56 68.78"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensionEmptyIcon);
export default __webpack_public_path__ + "static/media/extension-empty-icon.3e7bb504f76a74ce28461ba8d22d6677.svg";
export { ForwardRef as ReactComponent };